import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Modal } from '@honda-canada/design-system-react';
import StatusChangeModalContent from './StatusChangeModalContent';
import { useAppSelector } from '../../core/utils';
import { selectCurrentVehicleUrlQueryString } from '../../core/reducers/currentVehicle';
const StatusChange = ({ openModal, modalMessage, redirectOnClose, redirectUrl, updateStatusInUrl, }) => {
    const history = useHistory();
    const { pathname } = useLocation();
    const urlParams = useAppSelector(selectCurrentVehicleUrlQueryString);
    const modelCloseHandler = () => {
        if (redirectOnClose && redirectUrl) {
            history.replace(redirectUrl);
            return;
        }
        const { shouldUpdate, newStatus } = updateStatusInUrl;
        // on modal close, update inventoryStatus in URL to latest value
        if (shouldUpdate && newStatus) {
            const queryParams = new URLSearchParams(urlParams);
            queryParams.set('inventoryStatus', newStatus);
            const newUrl = `${pathname}?${queryParams.toString()}`;
            if (newUrl)
                history.replace(newUrl);
        }
    };
    return (React.createElement(Modal, { isOpen: openModal, allowClose: true, closeModal: modelCloseHandler, ariaLabel: modalMessage, padding: "0", closeBtnStyledProps: { display: 'none' } }, () => React.createElement(StatusChangeModalContent, { modalMessage: modalMessage, modelCloseHandler: modelCloseHandler })));
};
export default StatusChange;
